import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TransactionProgressComponent } from './transaction-progress/transaction-progress.component';
import { AppComponent } from './app.component';

const routes: Routes = [
  { path: 'transaction-progress', component: TransactionProgressComponent},
  { path: '', component: AppComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
